import { extendedTheme } from './extended'

export type { Theme } from './extended'
export default extendedTheme
